function SwatchesConstructor(t, e) {
    var n = this;
    (n.productIsValid = t.available && "Title" != t.options),
        (n.product_json = t),
        (n.options_name = ""),
        (n.options = ""),
        (n.viewDesign = window[e.viewDesign]),
        (n.contentParent = e.contentParent),
        (n.enableHistoryState = Boolean(e.enableHistoryState) || !1),
        (n.callback = e.callback || !1),
        (n.texture_obj = e.externalImagesObject || {}),
        (n.colors_obj = e.externalColors || {}),
        (n.color_with_border = e.colorWithBorder || {}),
        n.productIsValid && $(n.contentParent).length ? n.initSwatches() : n.callExternalVariantHandler(n.callback, t.variants[0], n.getJsonObject());
}
function getAllOptions(t) {
    for (var e = "", n = !0, r = {}, a = 0; a < t.length; a++)
        (e = String(t[a].title).replace(/\/ /g, "/").split("/")),
            (n = Boolean(t[a].available)),
            e[0] && n && (e[1] ? ((r[e[0]] = r[e[0]] || {}), e[2] ? ((r[e[0]][e[1]] = r[e[0]][e[1]] || {}), (r[e[0]][e[1]][e[2]] = !0)) : (r[e[0]][e[1]] = !0)) : (r[e[0]] = !0));
    return r;
}
function getCurrentVariantById(t, e) {
    for (var n = 0; n < t.length; n++)
        if (e) {
            if (t[n].id == e) return t[n];
        } else if (t[n].available) return t[n];
    return t[0];
}
function getCurrentVariantByTitle(t, e) {
    if (!e) return t[0];
    for (var n = 0; n < t.length; n++) {
        if (t[n].title.indexOf(e) > -1 && t[n].available) return t[n];
        n == t.length - 1 && e.indexOf("/") > -1 && ((e = e.split("/")).pop(), (e = e.length > 1 ? e.join("/") : e), (n = 0));
    }
    return t[0];
}
function getVariantIdUrl() {
    var t = location.search;
    return t.indexOf("variant=") > -1 && ((t = t.match(/variant=\d+/g)), (t = parseInt(t[0].match(/\d+/g)))), t;
}
function isEmpty(t) {
    return 0 === Object.keys(t).length;
}
function viewButtons(t, e) {
    e = e || {};
    var n = ".wrapper";
    switch (t) {
        case "getFunctionClickHandler":
            return "buttonHandler";
        case "getGroupElementName":
            return n;
        case "getGroupHtml":
            return '<div class="' + n.replace(/([\.#])/g, "") + '">' + ('<div class="title-options text-uppercase">' + e.title + ":</div>") + '<ul class="options options-large">' + e.html + "</ul></div>";
        case "getButtonHtml":
            var r = e.value.trim(),
                a = r.toLowerCase(),
                o = e.c_border.indexOf(r) > -1 ? " border" : "";
            (a = "," + a + ":"), (a = e.colors.indexOf(a) > -1 && e.colors.split(a).pop().split(",").shift().trim());
            var i = r in e.texture ? ' style="background:url(' + e.texture[r] + ')"' : "";
            "" == i && a && (i = ' style="background:' + a + ';"');
            var l = "" != i ? '<li><a href="#" class="options-color' + o + '" data-value="' + r + '" title="' + r + '" ' + i + "></a></li>" : '<li><a href="#" data-value="' + r + '" title="' + r + '">' + r + "</a></li>";
            return e.value != e.selected ? l : l.replace(/<li/, '<li class="active"');
    }
}
function viewSelect(t, e) {
    e = e || {};
    var n = ".wrapper";
    switch (t) {
        case "getFunctionClickHandler":
            return "selectHandler";
        case "getGroupElementName":
            return n;
        case "getGroupHtml":
            return '<div class="' + n.replace(/([\.#])/g, "") + '">' + ('<div class="title-options text-uppercase">' + e.title + ":</div>") + '<select class="form-control select-inline">' + e.html + "</select></div>";
        case "getButtonHtml":
            var r = "<option>" + e.value.trim() + "</option>";
            return e.value != e.selected ? r : r.replace(/<option/, "<option selected");
    }
}
(SwatchesConstructor.prototype.destroy = function () {
    var t = $(this.contentParent);
    t.find("a").unbind(), t.find("select").unbind(), t.empty();
}),
    (SwatchesConstructor.prototype.initSwatches = function () {
        var t,
            e = this,
            n = [];
        t = e.getJsonObject().options;
        for (var r = 0; r < t.length; r++) n[r] = Object(t[r]).name;
        (e.options_name = n), (e.options = getAllOptions(e.getJsonObject().variants));
        var a = e.enableHistoryState && getVariantIdUrl();
        e.createSwatches(a);
    }),
    (SwatchesConstructor.prototype.createSwatches = function (t) {
        var e = this,
            n = e.viewDesign;
        if (isEmpty(e.options)) return !1;
        var r = getCurrentVariantById(e.getJsonObject().variants, t),
            a = String(r.title).replace(/\/ /g, "/").split("/");
        e.createOptionsView(e.contentParent, e.options, e.options_name, a), e[n("getFunctionClickHandler")](), e.callExternalVariantHandler(e.callback, r, e.getJsonObject());
    }),
    (SwatchesConstructor.prototype.buttonHandler = function () {
        var t = this,
            e = t.viewDesign,
            n = $(t.contentParent),
            r = e("getGroupElementName"),
            a = n.find(r);
        a.find("a").click(function (e) {                
            if ((e.preventDefault(), $(this).hasClass("active"))) return !1;
            a.find("a").unbind(), $(this).closest(r).find(".active").removeClass("active"), $(this).parent().addClass("active");
            var o = "";
            n
                .find(".active")
                .find("[data-value]")
                .each(function () {
                    o += $(this).attr("data-value") + " / ";
                }),
                t.endOfTheClickHandler(o);         
          setTimeout(function(){
          if(typeof checkIwish !== 'undefined' && typeof checkIwish === 'function') {
            var iwishfrmobj = $('.product-info');
            var provid = iwishfrmobj.find("[name=id]").val();            
            checkIwish(iwishfrmobj, provid);
          }
            }, 900);
          
        });
    }),
    (SwatchesConstructor.prototype.selectHandler = function () {
        var t = this,
            e = t.viewDesign,
            n = $(t.contentParent),
            r = e("getGroupElementName");
        n.find(r)
            .find("select")
            .change(function () {
                var e = "";
                n.find("select option:selected").each(function () {
                    e += $(this).text() + " / ";
                }),
                    t.endOfTheClickHandler(e);
            });
    }),
    (SwatchesConstructor.prototype.endOfTheClickHandler = function (t) {
        var e = this;
        t = t.substring(0, t.length - 3);
        var n = getCurrentVariantByTitle(e.getJsonObject().variants, t);
        e.enableHistoryState && history.pushState(null, null, location.pathname + "?variant=" + n.id), e.createSwatches(n.id);
    }),
    (SwatchesConstructor.prototype.createOptionsView = function (t, e, n, r) {
        var a = this,
            o = a.viewDesign,
            i = $(t).empty(),
            l = a.texture_obj,
            c = a.colors_obj,
            s = a.color_with_border,
            u = "",
            p = "",
            d = "",
            v = "getButtonHtml";
        $.each(e, function (t) {
            if (t == r[0] && "object" == typeof e[t] && "Default Title" != t) {
                var a = e[t];
                $.each(a, function (t) {
                    t == r[1] &&
                        "object" == typeof a[t] &&
                        $.each(a[t], function (t) {
                            d += o(v, { value: t, selected: r[2], title: n[2], texture: l, colors: c, c_border: s });
                        }),
                        (p += o(v, { value: t, selected: r[1], title: n[1], texture: l, colors: c, c_border: s }));
                });
            }
            "Default Title" != t && (u += o(v, { value: t, selected: r[0], title: n[0], texture: l, colors: c, c_border: s }));
        });
        for (var f = [n[0], n[1], n[2]], h = [u, p, d], g = 0; g < h.length; g++) "" != h[g] && i.append(o("getGroupHtml", { title: f[g], html: h[g] }));
    }),
    (SwatchesConstructor.prototype.getJsonObject = function () {
        return this.product_json;
    }),
    (SwatchesConstructor.prototype.callExternalVariantHandler = function (t, e, n) {
        t && "function" == typeof t && t(e, n);
    });
